import { Dispatch, SetStateAction, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useApiCall from '../../../../../hooks/useApiCall';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { useQuery } from '../../../../../hooks/useQuery';
import ConsultsService from '../../../../../services/ConsultsService';
import MyModal from '../../../../Modal';
import { ICreateInstructionApiResponse, Rotas, TrajetoInstruc } from '../types';

interface IDeleteAllByDirectionModal {
  directionToBeRemoved: 'going' | 'returning';
  deleteAllByDirectionModalShow: boolean;
  setDeleteAllByDirectionModalShow: Dispatch<SetStateAction<boolean>>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  setInstructions: Dispatch<SetStateAction<TrajetoInstruc[]>>;
  selectedRoute: Rotas;
  isMultiRoute: boolean;
}

export default function DeleteAllByDirectionModal({
  directionToBeRemoved,
  deleteAllByDirectionModalShow,
  setDeleteAllByDirectionModalShow,
  setIsLoading,
  setInstructions,
  selectedRoute,
  isMultiRoute,
}: IDeleteAllByDirectionModal) {
  const { apiCall } = useApiCall();
  const { userCode, userProfile } = useGetGeneralAppData();
  const query = useQuery();
  const companyCode = query.get('codEmpresa');
  const { consultCode } = useParams();

  const removeAllInstructionsOfDirection = useCallback(async () => {
    await apiCall({
      apiToCall: ConsultsService.removeOrEditInstruction,
      reqBody: JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        tipoAcao: 5,
        codEmpresa: Number(companyCode),
        codConsulta: Number(consultCode),
        rota: isMultiRoute ? selectedRoute.rota : 1,
        codSentido: isMultiRoute ? selectedRoute.sentido : directionToBeRemoved === 'going' ? 1 : 2,
        sequencia: 0,
        trajetoInstrucoes: {
          tipoInstrucao: 0,
          instrucao: '',
          sequencia: 0,
          origem: '',
          destino: '',
          linhaTransporte: '',
          routeID: '',
          tempo: 0,
          distancia: 0,
          origemLat: 0,
          origemLng: 0,
          destinoLat: 0,
          destinoLng: 0,
          codGeo: '',
          codItem: 0,
          tarifa: 0,
        }

      }),
      onStartLoad: () => setIsLoading(true),
      onEndLoad: () => setIsLoading(false),
      catchMessage: 'Não foi possível remover as instruções. Por favor, tente novamente',
      actionAfterResponse: (response: ICreateInstructionApiResponse) => {
        if (!response.codigo) {
          toast.error(`Não foi possível remover as instruções. Por favor, tente novamente (${response.msg})`);
          return;
        }
        setDeleteAllByDirectionModalShow(false);
        toast.success('As instruções foram removidas com sucesso. Conclua a roteirização, ou adicione mais instruções!');
        setInstructions(response.trajetoInstrucoes);
      }
    });
  }, [apiCall, companyCode, consultCode, directionToBeRemoved, isMultiRoute, selectedRoute?.rota, selectedRoute?.sentido, setDeleteAllByDirectionModalShow, setInstructions, setIsLoading, userCode, userProfile]);

  return (
    <MyModal
      show={deleteAllByDirectionModalShow}
      title="Remover Todas as Instruções do trecho / sentido"
      closeButtonLabel="Fechar"
      actionButtonLabel="Remover instruções"
      onClose={() => setDeleteAllByDirectionModalShow(false)}
      onAction={() => removeAllInstructionsOfDirection()}
      // isActionButtonDisabled={!selectedItem.value}
      type="deleteAction"
      size='lg'
      modalBody={(
        <>
          Tem certeza que deseja remover todas as instruções {isMultiRoute ? `do trecho ${selectedRoute.rota}` : `da ${directionToBeRemoved === 'going' ? 'IDA' : 'VOLTA'}`}?
        </>
      )}
    />
  );
}
